const validate = (input: any) => {
  interface errorsInterface {
    pass?: string;
    email?: string;
  }

  let errors: errorsInterface = {};

  // Validación de contraseña
  if (!/^.{5,}$/.test(input.pass)) {
    errors.pass = 'Invalid password - The password must be at least 5 characters long.';
  }
  

  // Validación de correo electrónico
  if (!/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/.test(input.email)) {
    errors.email = 'email is invalid';
  }

  return errors;
};

export default validate;
